import { all } from 'redux-saga/effects';

import users from '../entities/Users/users.saga';
import accounts from '../entities/Account/account.saga';

export default function* rootSaga() {
  yield all([users(), accounts()]);
}
